/* eslint-disable react/no-danger */
import React from 'react';
import i18next from 'i18next';
import './stylesheet.scss';

const Explain = () => (
  <div className="container">
    <div className="account-confirm-explain">
      <p>{i18next.t('components.account.confirm.explain.m1')}</p>
      <p
        dangerouslySetInnerHTML={{
          __html: i18next.t('components.account.confirm.explain.m2', { interpolation: { escapeValue: false } }).replace('%url_marketplace_legals%', '/block/marketplace_legals?modal=true'),
        }}
      />
    </div>
  </div>
);

export default Explain;
